const SUBSCRIPTION_INTERVAL = {
  MONTHLY: "monthly",
  YEARLY: "yearly",
};

export default SUBSCRIPTION_INTERVAL;
